//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "",
  components: {},
  data() {
    return {
      BackButton: {
        Type: "default"
      }
    };
  },
  props: ["dataConfig", "isShowBack"],
  computed: {},
  methods: {
    onBackClick() {
      this.$msg.confirm("是否确定要返回?", () => {
        window.history.back(-1);
      });
    },

    onButtonClick(buttonItem) {
      if(buttonItem && buttonItem.OnClick){
        buttonItem.OnClick(buttonItem);
      }
    }
  }
};
